import { z } from "zod";

/**
 * Lead "color label" types shared between the API (which computes them) and the web app
 * (which maps each key to a color, display string and tooltip).
 *
 * The tuple order encodes display priority — the frontend uses the first label as the
 * primary stripe color. It mirrors the original client-side push order:
 * red → blue → yellow → grey → green.
 */
export const LEAD_LABEL_TYPES = [
	"IN_ACTIVE_CAMPAIGN",
	"CONNECTED_ON_LINKEDIN",
	"PREVIOUS_OUTREACH",
	"ON_OTHER_LISTS",
	"NEW_LEAD",
] as const;

export type LeadLabelType = (typeof LEAD_LABEL_TYPES)[number];

export const leadLabelTypeSchema = z.enum(LEAD_LABEL_TYPES);

export const leadLabelsSchema = z.array(leadLabelTypeSchema);

export type LeadLabels = z.infer<typeof leadLabelsSchema>;
